import { WorkspaceProduct } from 'features/product/types/workspaceProduct'
import { GetProductsByStatus } from './types'

export const groupProducts = (products: WorkspaceProduct[]): GetProductsByStatus => ({
  active: products.filter((product: WorkspaceProduct) => product.status !== 'inactive'),
  recommended: products.filter((product: WorkspaceProduct) => product.status === 'inactive'),
})
